import { registerPlugin } from "@capacitor/core"

export interface NexusCapacitorPlugin {
  setUserId(userId: string): Promise<{ value: string }>
}

const NexusCapacitorPlugin = registerPlugin<NexusCapacitorPlugin>("NexusPlugin")

export default NexusCapacitorPlugin
